const SpinnerIcon = ({ className = "" }) => (
    <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={`tw:animate-spin ${className}`}
    >
        <path 
            d="M12 4.75V6.25" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M17.1266 6.87347L16.0659 7.93413" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M19.25 12L17.75 12" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M17.1266 17.1265L16.0659 16.0659" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M12 17.75V19.25" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            opacity="0.5"
        />
        <path 
            d="M6.87347 17.1265L7.93413 16.0659" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            opacity="0.5"
        />
        <path 
            d="M6.25 12L4.75 12" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            opacity="0.5"
        />
        <path 
            d="M6.87347 6.87347L7.93413 7.93413" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            opacity="0.25"
        />
    </svg>
)

export default SpinnerIcon